import sendRequest from "../../../helpers/requestHelper";
import config from "../../../config";
import eventBus from "../../../event-bus/eventBus";
import {handleError} from "../../../helpers/handleError";

const pendingOffer = {
    namespaced: true,
    state: {
        dataPendingIsFetching: false,
        typeInfoOfferPending: "",
        headInfoOfferPending: "",
        isOfferPending: false,
        textInfoOfferPending: ""
    },
    mutations: {
        DATA_SAVE_REQUEST(state, value) {
            state.dataPendingIsFetching = value;
        },
        DATA_SAVE_SUCCESS(state, response) {
            let dataReceive = {
                message: response.data.data.textInfo,
                title: response.message
            };
            state.isOfferPending = true;
            state.dataPendingIsFetching = false;
            eventBus.$emit("pendingOfferSuccess", dataReceive);
        },
        DATA_SAVE_FAILURE(state, error) {
            state.textInfoOfferPending = handleError(error) !== "" ? handleError(error) : error.response.data.data.message;
            state.typeInfoOfferPending = "red";
            state.headInfoOfferPending = error.response.data.message;
            state.isOfferPending = true;
            state.dataPendingIsFetching = false;
            eventBus.$emit("pendingOfferFailure", error.response.data.errors);
        },
        UPDATE_VISIBLE_MODAL(state, value) {
            state.isOfferPending = value;
        }
    },
    actions: {
        pendingOfferRequest: function({dispatch, state}, value) {
            state.dataPendingIsFetching = true;
            console.log(value)
            let promise = sendRequest("put", config.baseURLApi + "/offers/pending/" + value, {}, {});
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("successDataPending", result[1])
                } else {
                    dispatch("failureDataPending", result[1]);
                }
                state.dataPendingIsFetching = false;
            });
        },
        requestDataPending: function({commit}, value) {
            commit("DATA_SAVE_REQUEST", value);
        },
        successDataPending: function({commit}, response) {
            commit("DATA_SAVE_SUCCESS", response);
        },
        failureDataPending: function({commit}, error) {
            commit("DATA_SAVE_FAILURE", error);
        },
        updateVisibleModal: function({ commit }, value) {
            commit("UPDATE_VISIBLE_MODAL", value);
        }
    }
}

export default pendingOffer;